/* eslint-disable */

import enhancer from './Runtime.enhancer';
import View from './Runtime';

export default enhancer(View);
